import { axios } from 'services/axios';

/**
 * Normalise API response field names to the form's internal names.
 * API → Form: platformReferenceID → organizationId, apiKeyValidTo → keyExpiry
 */
const normaliseProvider = (p) => ({
    ...p,
    organizationId: p.platformReferenceID ?? '',
    keyExpiry: p.apiKeyValidTo ?? '',
});

/**
 * Map form fields to the API payload shape.
 * Form → API: organizationId → platformReferenceID, keyExpiry → apiKeyValidTo
 */
const toApiPayload = (fields) => ({
    name: fields.name,
    description: fields.description ?? '',
    platformReferenceID: fields.organizationId,
    isActive: fields.isActive !== undefined ? fields.isActive : true,
    ...(fields.apiKey !== undefined ? { apiKey: fields.apiKey } : {}),
    ...(fields.keyExpiry ? { apiKeyValidTo: fields.keyExpiry } : {}),
});

export const getServiceProviders = async (scope) => {
    const response = await axios.get('/ServiceProviders/EightByEight', {
        headers: { 'X-RequestScope': scope },
    });
    const items = Array.isArray(response.data) ? response.data : [];
    return { status: 200, data: items.map(normaliseProvider) };
};

export const getServiceProviderById = async (id, scope) => {
    const response = await axios.get(`/ServiceProvider/${id}`, {
        headers: { 'X-RequestScope': scope },
    });
    return { status: 200, data: normaliseProvider(response.data) };
};

export const createServiceProvider = async (fields, platformId, scope) => {
    const response = await axios.post(
        '/ServiceProvider',
        { ...toApiPayload(fields), platformID: platformId },
        { headers: { 'X-RequestScope': scope } },
    );
    return { status: 200, data: normaliseProvider(response.data) };
};

export const updateServiceProvider = async (id, fields, scope) => {
    const response = await axios.put(
        '/ServiceProvider',
        { id, ...toApiPayload(fields) },
        { headers: { 'X-RequestScope': scope } },
    );
    return { status: 200, data: normaliseProvider(response.data) };
};

export const deleteServiceProvider = async (id, scope) => {
    const response = await axios.delete(`/ServiceProvider/${id}`, {
        headers: { 'X-RequestScope': scope },
    });
    return { status: 200, data: response.data };
};
